import { HttpClient } from '../HttpClient';
/**
 * * Get Web Settings
 */
export const GetWebSettings = async () => {
  try {
    const { data } = await HttpClient.get('api/web/settings');
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
